import { motion } from "framer-motion";
import { ArrowUpRight, FileSearch } from "lucide-react";

const EASE = [0.16, 1, 0.3, 1];
export const SMARTCREDIT_URL = "https://www.smartcredit.com";

const CreditAccess = () => (
  <section className="bg-ink-base pb-4" data-testid="credit-access-section">
    <div className="max-w-7xl mx-auto px-6 lg:px-10">
      <motion.div
        initial={{ opacity: 0, y: 32 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, margin: "-60px" }}
        transition={{ duration: 0.9, ease: EASE }}
        className="relative overflow-hidden border border-gold/30 bg-gold/[0.04] px-8 py-10 lg:px-14 lg:py-12 flex flex-col lg:flex-row lg:items-center gap-8"
      >
        <span className="pointer-events-none select-none absolute -right-8 -top-14 font-serif italic text-[11rem] leading-none text-stroke-gold opacity-30 hidden lg:block" aria-hidden="true">
          $1
        </span>
        <div className="flex-1 relative">
          <div className="flex items-center gap-3">
            <FileSearch className="w-5 h-5 text-gold" strokeWidth={1.5} />
            <p className="font-mono text-[11px] uppercase tracking-[0.3em] text-gold">See what lenders see</p>
          </div>
          <h3 className="mt-4 font-serif text-2xl lg:text-3xl text-white tracking-tight">
            Pull all three credit reports with SmartCredit's <span className="italic text-gold">$1 trial.</span>
          </h3>
          <p className="mt-3 text-sm text-neutral-400 font-light leading-relaxed max-w-2xl">
            Your seven-day trial unlocks your complete three-bureau reports and scores —
            the exact data we analyze together in your personal action plan. Arrive informed.
          </p>
        </div>
        <a
          href={SMARTCREDIT_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="group relative shrink-0 inline-flex items-center gap-3 bg-gold text-black text-xs font-medium uppercase tracking-[0.15em] px-8 py-4 hover:bg-white transition-colors duration-300"
          data-testid="smartcredit-cta"
        >
          Access Your Credit — $1 Trial
          <ArrowUpRight className="w-4 h-4 transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1" />
        </a>
      </motion.div>
    </div>
  </section>
);

export default CreditAccess;
